import {Buffer} from 'buffer';
import config from '../../data/config';

export const getFullImageUrl = (imageUrl: string) =>
  `${config.baseURL}api/common/content/${imageUrl}`;

export const binaryToBase64 = (binary: string) => {
  const base64 = Buffer.from(binary, 'binary').toString('base64');
  return `data:image/jpeg;base64,${base64}`;
};
